import { images } from '../../Constants/ImageUrls';

export const maternityGeneralItem = [
  {
    items: [
      {
        product_id: 2072,
        sectionOrder: 1,
        style: 'Maxi Dress',
        print: 'Blue Ditsy Daisy',
        showOnLp: true,
        sizeSkus: '2071, 2072, 2073, 2074',
        size: 'L',
        name: 'Pre&Post Maternity /Nursing Maxi Dress with both sides Zipper for Easy Feeding – Blue Ditsy Daisy –L',
        webUrl:
          'mylofamily.com/essentials/pre-post-maternity-nursing-tiny-floral-maxi-dress-with-bell-sleeves-both-sides-zipper-for-easy-feedi-2072',
        imageUrl:
          'https://images.myloapp.in/NestJsUploads/1678703033581-2071,-2072,-2073,-2074.webp',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156349-maxi.webp',
        MRP: 1549,
        status: 'Active',
        strikeprice: 1799,
        price: 1375,
        Discount: 0.112330535829567,
      },
      {
        product_id: 2024,
        sectionOrder: 1,
        style: 'Maxi Dress',
        print: 'Garden Flowers -Navy',
        showOnLp: true,
        sizeSkus: '2023, 2024, 2025, 2026',
        size: 'L',
        name: 'Pre&Post Maternity /Nursing Maxi Dress with both sides Zipper for Easy Feeding – Garden Flowers -Navy –L',
        webUrl:
          'mylofamily.com/essentials/Pre--Post-Maternity-Nursing-Garden-Flowers-Maxi-Dress-with-both-sides-Zipper-for-Easy-Feeding--NavyL-2024',
        imageUrl:
          'https://images.myloapp.in/NestJsUploads/1678703263996-2023,-2024,-2025,-2026.webp',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156349-maxi.webp',
        MRP: 1399,
        status: 'OOS',
        strikeprice: 1799,
        price: 1799,
        Discount: 0.0886347390993567,
      },
      {
        product_id: 2016,
        sectionOrder: 1,
        style: 'Maxi Dress',
        print: 'Garden Flowers -Teal',
        showOnLp: true,
        sizeSkus: '2015, 2016, 2017, 2018',
        size: 'L',
        name: 'Pre&Post Maternity /Nursing Maxi Dress with both sides Zipper for Easy Feeding – Garden Flowers -Teal –L',
        webUrl:
          'mylofamily.com/essentials/Pre--Post-Maternity-Nursing-Garden-Flower-Maxi-Dress-with-both-sides-Zipper-for-Easy-Feeding--TealL-2016',
        imageUrl:
          'https://images.myloapp.in/NestJsUploads/1678703263996-2015,-2016,-2017,-2018.webp',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156349-maxi.webp',
        MRP: 1399,
        status: 'Active',
        strikeprice: 1799,
        price: 1275,
        Discount: 0.0886347390993567,
      },
      {
        product_id: 2020,
        sectionOrder: 1,
        style: 'Maxi Dress',
        print: 'Garden Flowers -Wine',
        showOnLp: true,
        sizeSkus: '2019, 2020, 2021, 2022',
        size: 'L',
        name: 'Pre&Post Maternity /Nursing Maxi Dress with both sides Zipper for Easy Feeding – Garden Flowers -Wine –L',
        webUrl:
          'mylofamily.com/essentials/Pre--Post-Maternity-Nursing-Garden-Flowers-Maxi-Dress-with-both-sides-Zipper-for-Easy-Feeding--WineL-2020',
        imageUrl:
          'https://images.myloapp.in/NestJsUploads/1678703263996-2019,-2020,-2021,-2022.webp',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156349-maxi.webp',
        MRP: 1399,
        status: 'Active',
        strikeprice: 1799,
        price: 1275,
        Discount: 0.0886347390993567,
      },
      {
        product_id: 2032,
        sectionOrder: 1,
        style: 'Maxi Dress',
        print: 'Geometric Blue',
        showOnLp: true,
        sizeSkus: '2031, 2032, 2033, 2034',
        size: 'L',
        name: 'Pre&Post Maternity /Nursing Maxi Dress with both sides Zipper for Easy Feeding – Geometric Blue–L',
        webUrl:
          'mylofamily.com/essentials/Pre--Post-Maternity-Nursing-MaxiDress-with-both-sides-Zipper-for-Easy-Feeding-Geometric-Greyish-Blue-2032',
        imageUrl:
          'https://images.myloapp.in/NestJsUploads/1678703263995-2031,-2032,-2033,-2034.webp',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156349-maxi.webp',
        MRP: 1449,
        status: 'Active',
        strikeprice: 1799,
        price: 1375,
        Discount: 0.0510697032436163,
      },
      {
        product_id: 2028,
        sectionOrder: 1,
        style: 'Maxi Dress',
        print: 'Geometric Pink',
        showOnLp: true,
        sizeSkus: '2027, 2028, 2029, 2030',
        size: 'L',
        name: 'Pre&Post Maternity /Nursing Maxi Dress with both sides Zipper for Easy Feeding – Geometric Pink–L',
        webUrl:
          'mylofamily.com/essentials/Pre--Post-Maternity-Nursing-MaxiDress-with-both-sides-Zipper-for-Easy-Feeding-Geometric-PinkL-2028',
        imageUrl:
          'https://images.myloapp.in/NestJsUploads/1678703263993-2027,-2028,-2029,-2030.webp',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156349-maxi.webp',
        MRP: 1449,
        status: 'Active',
        strikeprice: 1799,
        price: 1799,
        Discount: 0.0510697032436163,
      },
      {
        product_id: 2409,
        sectionOrder: 1,
        style: 'Maxi Dress',
        print: 'Hawaiian Blue',
        showOnLp: true,
        sizeSkus: '2408, 2409, 2410, 2411',
        size: 'L',
        name: 'Pre&Post Maternity /Nursing, Asymmetrical Solid Maxi Dress with both sides Zipper for Easy Feeding - Hawaiian Blue-L',
        webUrl:
          'mylofamily.com/essentials/pre-post-maternity-nursing-asymmetrical-maxi-dress-with-both-sides-zipper-for-easy-feeding---hawaiia-2409',
        imageUrl:
          'https://images.myloapp.in/NestJsUploads/1678703363724-2408,-2409,-2410,-2411.webp',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156349-maxi.webp',
        MRP: 1999,
        status: 'Active',
        strikeprice: 1999,
        price: 1299,
        Discount: 0.350175087543772,
      },
      {
        product_id: 2413,
        sectionOrder: 1,
        style: 'Maxi Dress',
        print: 'Hawaiian Pink',
        showOnLp: true,
        sizeSkus: '2412, 2413, 2414, 2416',
        size: 'L',
        name: 'Pre&Post Maternity /Nursing, Asymmetrical Solid Maxi Dress with both sides Zipper for Easy Feeding - Hawaiian Pink-L',
        webUrl:
          'mylofamily.com/essentials/pre-post-maternity-nursing-asymmetrical-maxi-dress-with-both-sides-zipper-for-easy-feeding---hawaiia-2413',
        imageUrl:
          'https://images.myloapp.in/NestJsUploads/1678703363724-2412,-2413,-2414,-2416.webp',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156349-maxi.webp',
        MRP: 1999,
        status: 'Active',
        strikeprice: 1999,
        price: 1299,
        Discount: 0.350175087543772,
      },
      {
        product_id: 2375,
        sectionOrder: 1,
        style: 'Maxi Dress',
        print: 'Little Hearts - Navy',
        showOnLp: true,
        sizeSkus: '2374, 2375, 2376, 2377',
        size: 'L',
        name: 'Pre&Post Maternity/Nursing Full Length Nighty with both sides Zipper for Easy Feeding - Little Hearts - Navy - L',
        webUrl:
          'mylofamily.com/essentials/pre-post-maternitynursing-full-length-nighty-with-both-sides-zipper-for-easy-feeding---little-hearts-2375',
        imageUrl:
          'https://images.myloapp.in/NestJsUploads/1678703363723-2374,-2375,-2376,-2377.webp',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156349-maxi.webp',
        MRP: 1999,
        status: 'OOS',
        strikeprice: 1999,
        price: 1299,
        Discount: 0.350175087543772,
      },
      {
        product_id: 2371,
        sectionOrder: 1,
        style: 'Maxi Dress',
        print: 'Little Hearts - Sea Green',
        showOnLp: true,
        sizeSkus: '2370, 2371, 2372',
        size: 'L',
        name: 'Pre&Post Maternity Maxi Length Nighty with Zipper at both sides for Easy Feeding - Little Hearts - Sea Green - L',
        webUrl:
          'mylofamily.com/essentials/pre-post-maternity-maxi-length-nighty-with-zipper-at-both-sides-for-easy-feeding---little-hearts---s-2371',
        imageUrl:
          'https://images.myloapp.in/NestJsUploads/1678703363723-2370,-2371,-2372,2373.webp',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156349-maxi.webp',
        MRP: 1999,
        status: 'OOS',
        strikeprice: 1999,
        price: 1299,
        Discount: 0.350175087543772,
      },
      {
        product_id: 2214,
        sectionOrder: 1,
        style: 'Maxi Dress',
        print: 'Miami Cream',
        showOnLp: true,
        sizeSkus: '2213, 2214, 2215, 2216',
        size: 'L',
        name: 'Pre&Post Maternity /Nursing Maxi Dress cum Kurti with both sides Zipper for Easy Feeding – Miami Cream–L',
        webUrl:
          'mylofamily.com/essentials/pre-post-maternity-nursingtiny-floral-prints-maxi-dress-with-both-sides-zipper-for-easy-feeding---mi-2214',
        imageUrl:
          'https://images.myloapp.in/NestJsUploads/1678703363723-2213,-2214,-2215,-2216.webp',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156349-maxi.webp',
        MRP: 1799,
        status: 'OOS',
        strikeprice: 1799,
        price: 1449,
        Discount: 0.194552529182879,
      },
      {
        product_id: 2222,
        sectionOrder: 1,
        style: 'Maxi Dress',
        print: 'Miami Green',
        showOnLp: true,
        sizeSkus: '2221, 2222, 2223, 2224',
        size: 'L',
        name: 'Pre&Post Maternity /Nursing Maxi Dress with both sides Zipper for Easy Feeding – Miami Green –L',
        webUrl:
          'mylofamily.com/essentials/pre-post-maternity-nursingtiny-floral-prints-maxi-dress-with-both-sides-zipper-for-easy-feeding---mi-2222',
        imageUrl:
          'https://images.myloapp.in/NestJsUploads/1678703480418-2221,-2222,-2223,-2224.webp',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156349-maxi.webp',
        MRP: 1799,
        status: 'Active',
        strikeprice: 1799,
        price: 1449,
        Discount: 0.194552529182879,
      },
      {
        product_id: 2218,
        sectionOrder: 1,
        style: 'Maxi Dress',
        print: 'Miami Wine',
        showOnLp: true,
        sizeSkus: '2217, 2218',
        size: 'L',
        name: 'Pre&Post Maternity /Nursing Maxi Dress cum Kurti with both sides Zipper for Easy Feeding – Miami Wine –L',
        webUrl:
          'mylofamily.com/essentials/pre-post-maternity-nursingtiny-floral-prints-maxi-dress-with-both-sides-zipper-for-easy-feeding---mi-2218',
        imageUrl:
          'https://images.myloapp.in/NestJsUploads/1678703480418-2217,-2218,-2219,2220.webp',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156349-maxi.webp',
        MRP: 1799,
        status: 'OOS',
        strikeprice: 1799,
        price: 1449,
        Discount: 0.194552529182879,
      },
      {
        product_id: 2076,
        sectionOrder: 1,
        style: 'Maxi Dress',
        print: 'Mustard Ditsy Daisy',
        showOnLp: true,
        sizeSkus: '2075, 2076, 2077, 2078',
        size: 'L',
        name: 'Pre&Post Maternity /Nursing Maxi Dress with both sides Zipper for Easy Feeding – Mustard Ditsy Daisy –L',
        webUrl:
          'mylofamily.com/essentials/pre-post-maternity-nursing-tiny-floral-maxi-dress-with-bell-sleeves-both-sides-zipper-for-easy-feedi-2076',
        imageUrl:
          'https://images.myloapp.in/NestJsUploads/1678703480418-2075,-2076,-2077,-2078.webp',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156349-maxi.webp',
        MRP: 1549,
        status: 'Active',
        strikeprice: 1799,
        price: 1375,
        Discount: 0.112330535829567,
      },
      {
        product_id: 2238,
        sectionOrder: 1,
        style: 'Maxi Dress',
        print: 'Persian Paisley - Blue',
        showOnLp: true,
        sizeSkus: '2237, 2238, 2239, 2240',
        size: 'L',
        name: 'Pre&Post Maternity /Nursing Maxi Dress with both sides Zipper for Easy Feeding – Persian Paisley Blue–L',
        webUrl:
          'mylofamily.com/essentials/pre-post-maternity-nursingpersian-paisley-maxi-dress-with-both-sides-zipper-for-easy-feeding---blue--2238',
        imageUrl:
          'https://images.myloapp.in/NestJsUploads/1678703480417-2237,-2238,-2239,-2240.webp',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156349-maxi.webp',
        MRP: 1799,
        status: 'Active',
        strikeprice: 1799,
        price: 1549,
        Discount: 0.138966092273485,
      },
      {
        product_id: 2246,
        sectionOrder: 1,
        style: 'Maxi Dress',
        print: 'Persian Paisley - Green',
        showOnLp: true,
        sizeSkus: '2245, 2246, 2247, 2248',
        size: 'L',
        name: 'Pre&Post Maternity /Nursing Maxi Dress with both sides Zipper for Easy Feeding – Persian Paisley Green–L',
        webUrl:
          'mylofamily.com/essentials/pre-post-maternity-nursingpersian-paisley-maxi-dress-with-both-sides-zipper-for-easy-feeding---green-2246',
        imageUrl:
          'https://images.myloapp.in/NestJsUploads/1678703480417-2245,-2246,-2247,-2248.webp',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156349-maxi.webp',
        MRP: 1799,
        status: 'OOS',
        strikeprice: 1799,
        price: 1549,
        Discount: 0.138966092273485,
      },
      {
        product_id: 2242,
        sectionOrder: 1,
        style: 'Maxi Dress',
        print: 'Persian Paisley - Pink',
        showOnLp: true,
        sizeSkus: '2241, 2242, 2243, 2244',
        size: 'L',
        name: 'Pre&Post Maternity /Nursing Maxi Dress with both sides Zipper for Easy Feeding – Persian Paisley Pink–L',
        webUrl:
          'mylofamily.com/essentials/pre-post-maternity-nursingpersian-paisley-maxi-dress-with-both-sides-zipper-for-easy-feeding---pink--2242',
        imageUrl:
          'https://images.myloapp.in/NestJsUploads/1678703592163-2241,-2242,-2243,-2244.webp',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156349-maxi.webp',
        MRP: 1799,
        status: 'Active',
        strikeprice: 1799,
        price: 1549,
        Discount: 0.138966092273485,
      },
      {
        product_id: 2080,
        sectionOrder: 1,
        style: 'Maxi Dress',
        print: 'Pink Ditsy Daisy',
        showOnLp: true,
        sizeSkus: '2079, 2080, 2081, 2082',
        size: 'L',
        name: 'Pre&Post Maternity /Nursing Maxi Dress with both sides Zipper for Easy Feeding – Pink Ditsy Daisy – L',
        webUrl:
          'mylofamily.com/essentials/pre-post-maternity-nursing-tiny-floral-maxi-dress-with-bell-sleeves-both-sides-zipper-for-easy-feedi-2080',
        imageUrl:
          'https://images.myloapp.in/NestJsUploads/1678703592163-2079,-2080,-2081,-2082.webp',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156349-maxi.webp',
        MRP: 1549,
        status: 'Active',
        strikeprice: 1799,
        price: 1375,
        Discount: 0.112330535829567,
      },
    ],
    banner: images?.maxi,
    heading: 'Maxi Dress',
    id: 1,
  },
  {
    items: [
      {
        product_id: 2234,
        sectionOrder: 2,
        style: 'Midi Dress',
        print: 'Bora Bora Green',
        showOnLp: true,
        sizeSkus: '2233, 2234, 2235, 2236',
        size: 'L',
        name: 'Pre&Post Maternity /Nursing Midi Dress with both sides Zipper for Easy Feeding – Bora Bora Green–L',
        webUrl:
          'mylofamily.com/essentials/pre-post-maternity-nursingtiny-floral-prints-midi-dress-with-both-sides-zipper-for-easy-feeding---bo-2234',
        imageUrl:
          'https://images.myloapp.in/NestJsUploads/1678703592162-2233,-2234,-2235,-2236.webp',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156349-midi.webp',
        MRP: 1699,
        status: 'OOS',
        strikeprice: 1699,
        price: 1499,
        Discount: 0.117716303708064,
      },
      {
        product_id: 2230,
        sectionOrder: 2,
        style: 'Midi Dress',
        print: 'Bora Bora Grey',
        showOnLp: true,
        sizeSkus: '2229, 2230, 2231, 2232',
        size: 'L',
        name: 'Pre&Post Maternity /Nursing Midi Dress with both sides Zipper for Easy Feeding – Bora Bora Grey–L',
        webUrl:
          'mylofamily.com/essentials/pre-post-maternity-nursingtiny-floral-prints-midi-dress-with-both-sides-zipper-for-easy-feeding---bo-2230',
        imageUrl:
          'https://images.myloapp.in/NestJsUploads/1678703592162-2229,-2230,-2231,-2232.webp',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156349-midi.webp',
        MRP: 1699,
        status: 'Active',
        strikeprice: 1699,
        price: 1499,
        Discount: 0.117716303708064,
      },
      {
        product_id: 2226,
        sectionOrder: 2,
        style: 'Midi Dress',
        print: 'Bora Bora Navy',
        showOnLp: true,
        sizeSkus: '2225, 2226, 2227, 2228',
        size: 'L',
        name: 'Pre&Post Maternity /Nursing Midi Dress with both sides Zipper for Easy Feeding – Bora Bora Navy -L',
        webUrl:
          'mylofamily.com/essentials/pre-post-maternity-nursingtiny-floral-prints-midi-dress-with-both-sides-zipper-for-easy-feeding---bo-2226',
        imageUrl:
          'https://images.myloapp.in/NestJsUploads/1678703592162-2225,-2226,-2227,-2228.webp',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156349-midi.webp',
        MRP: 1699,
        status: 'Active',
        strikeprice: 1699,
        price: 1499,
        Discount: 0.117716303708064,
      },
      {
        product_id: 2418,
        sectionOrder: 2,
        style: 'Midi Dress',
        print: 'Siesta Green',
        showOnLp: true,
        sizeSkus: '2417, 2418, 2419, 2420',
        size: 'L',
        name: 'Pre&Post Maternity /Nursing Ruffle collared Solid Midi Dress with both sides Zipper for Easy Feeding – Siesta Green-L',
        webUrl:
          'mylofamily.com/essentials/pre-post-maternity-nursing-ruffle-collared-midi-dress-with-both-sides-zipper-for-easy-feeding---sies-2418',
        imageUrl:
          'https://images.myloapp.in/NestJsUploads/1678703679325-2417,-2418,-2419,-2420.webp',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156349-midi.webp',
        MRP: 1999,
        status: 'Active',
        strikeprice: 1999,
        price: 1299,
        Discount: 0.350175087543772,
      },
      {
        product_id: 2422,
        sectionOrder: 2,
        style: 'Midi Dress',
        print: 'Siesta Peach',
        showOnLp: true,
        sizeSkus: '2421, 2422, 2423, 2424',
        size: 'L',
        name: 'Pre&Post Maternity /Nursing Ruffle collared Solid Midi Dress with both sides Zipper for Easy Feeding – Siesta Peach-L',
        webUrl:
          'mylofamily.com/essentials/pre-post-maternity-nursing-ruffle-collared-midi-dress-with-both-sides-zipper-for-easy-feeding---sies-2422',
        imageUrl:
          'https://images.myloapp.in/NestJsUploads/1678703679325-2421,-2422,-2423,-2424.webp',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156349-midi.webp',
        MRP: 1999,
        status: 'OOS',
        strikeprice: 1999,
        price: 1299,
        Discount: 0.350175087543772,
      },
      {
        product_id: 2040,
        sectionOrder: 2,
        style: 'Midi Dress',
        print: 'Tropical Stripes - Navy',
        showOnLp: true,
        sizeSkus: '2039, 2040, 2041, 2042',
        size: 'L',
        name: 'Pre&Post Maternity /Nursing Midi Dress with both sides Zipper for Easy Feeding – Tropical Stripes-Navy - L',
        webUrl:
          'mylofamily.com/essentials/Pre--Post-Maternity-Nursing-Tropical-Striped-MaxiDress-with-both-sides-Zipper-for-Easy-FeedingNavyL-2040',
        imageUrl:
          'https://images.myloapp.in/NestJsUploads/1678703679325-2039,-2040,-2041,-2042.webp',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156349-midi.webp',
        MRP: 1549,
        status: 'Active',
        strikeprice: 1549,
        price: 1449,
        Discount: 0.0645577792123951,
      },
      {
        product_id: 2036,
        sectionOrder: 2,
        style: 'Midi Dress',
        print: 'Tropical Stripes-Red',
        showOnLp: true,
        sizeSkus: '2035, 2036, 2037, 2038',
        size: 'L',
        name: 'Pre&Post Maternity /Nursing Midi Dress with both sides Zipper for Easy Feeding – Tropical Stripes-Red - L',
        webUrl:
          'mylofamily.com/essentials/Pre--Post-Maternity-Nursing-Tropical-Striped-MaxiDress-with-both-sides-Zipper-for-Easy-Feeding-RedL-2036',
        imageUrl:
          'https://images.myloapp.in/NestJsUploads/1678703679324-2035,-2036,-2037,-2038.webp',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156349-midi.webp',
        MRP: 1549,
        status: 'Active',
        strikeprice: 1549,
        price: 1449,
        Discount: 0.0645577792123951,
      },
    ],
    banner: images?.midi,
    heading: 'Midi Dress',
    id: 2,
  },
  {
    items: [
      {
        product_id: 2062,
        sectionOrder: 3,
        style: 'Kaftan Style Dress',
        print: 'Shibori Print -Fuchsia',
        showOnLp: true,
        sizeSkus: '2061,2062,2063,2064',
        size: 'L',
        name: 'Pre&Post Maternity /Nursing Kaftan Maxi Dress cum Nighty with Zipper for Easy Feeding – Shibori Print -Fuchsia–L',
        webUrl:
          'mylofamily.com/essentials/pre-post-maternity-nursing-kaftan-maxi-dress-cum-nighty-with-both-sides-zipper-shibori--fuchsiam-2062',
        imageUrl:
          'https://images.myloapp.in/NestJsUploads/1678703033586-2061,-2062,-2063,-2064.webp',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156350-kaftan.webp',
        MRP: 1699,
        status: 'Active',
        strikeprice: 1699,
        price: 1199,
        Discount: 0.294290759270159,
      },
      {
        product_id: 2257,
        sectionOrder: 3,
        style: 'Kaftan Style Dress',
        print: 'Shibori Print -Navy',
        showOnLp: true,
        sizeSkus: '2256, 2257, 2258, 2259',
        size: 'L',
        name: 'Pre&Post Maternity /Nursing Kaftan Maxi Dress cum Nighty with Zipper for Easy Feeding – Shibori Print -Navy - L',
        webUrl:
          'mylofamily.com/essentials/pre-post-maternity-nursing-kaftan-maxi-dress-cum-nighty-with-zipper-for-easy-feeding-shibori-print---2257',
        imageUrl:
          'https://images.myloapp.in/NestJsUploads/1678703033586-2256,-2257,-2258,-2259.webp',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156350-kaftan.webp',
        MRP: 1699,
        status: 'Active',
        strikeprice: 1699,
        price: 1199,
        Discount: 0.294290759270159,
      },
      {
        product_id: 2066,
        sectionOrder: 3,
        style: 'Kaftan Style Dress',
        print: 'Shibori Print -Orange',
        showOnLp: true,
        sizeSkus: '2065, 2066, 2067, 2068',
        size: 'L',
        name: 'Pre&Post Maternity /Nursing Kaftan Maxi Dress cum Nighty with Zipper for Easy Feeding – Shibori Print -Orange- L',
        webUrl:
          'mylofamily.com/essentials/pre-post-maternity-nursing-kaftan-maxi-dress-cum-nighty-with-both-sides-zipper-shibori--mustardl-2066',
        imageUrl:
          'https://images.myloapp.in/NestJsUploads/1678703033586-2065,-2066,-2067,-2068.webp',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156350-kaftan.webp',
        MRP: 1699,
        status: 'OOS',
        strikeprice: 1699,
        price: 1699,
        Discount: 0.294290759270159,
      },
      {
        product_id: 2253,
        sectionOrder: 3,
        style: 'Kaftan Style Dress',
        print: 'Shibori Print -Sea Green',
        showOnLp: true,
        sizeSkus: '2252, 2253, 2254, 2255',
        size: 'L',
        name: 'Pre&Post Maternity /Nursing Kaftan Maxi Dress cum Nighty with Zipper for Easy Feeding – Shibori Print -Sea Green - L',
        webUrl:
          'mylofamily.com/essentials/pre-post-maternity-nursing-kaftan-maxi-dress-cum-nighty-with-zipper-for-easy-feeding-shibori-print---2253',
        imageUrl:
          'https://images.myloapp.in/NestJsUploads/1678703033585-2252,-2253,-2254,-2255.webp',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156350-kaftan.webp',
        MRP: 1699,
        status: 'Active',
        strikeprice: 1699,
        price: 1199,
        Discount: 0.294290759270159,
      },
    ],
    banner: images?.kaftan,
    heading: 'Kaftan Maxi',
    id: 3,
  },
  {
    items: [
      {
        product_id: 2371,
        sectionOrder: 4,
        style: 'Nighties',
        print: 'Little Hearts - Sea Green',
        showOnLp: true,
        sizeSkus: '2370, 2371, 2372',
        size: 'L',
        name: 'Pre &amp; Post Maternity Maxi Length Nighty with Zipper at both sides for Easy Feeding - Little Hearts - Sea Green - L',
        webUrl:
          'mylofamily.com/essentials/pre-post-maternity-maxi-length-nighty-with-zipper-at-both-sides-for-easy-feeding---little-hearts---s-2371',
        imageUrl:
          'https://images.myloapp.in/NestJsUploads/1680083392974-2370,-2371,-2372,-2373.webp',
        sizeChartUrl:
          'https://images.myloapp.in/gullack_products/product_1647254899_1925341984.jpeg',
        MRP: 1999,
        strikeprice: 1999,
        price: 1299,
        Discount: 0.35,
      },
      {
        product_id: 2375,
        sectionOrder: 4,
        style: 'Nighties',
        print: 'Little Hearts - Navy',
        showOnLp: true,
        sizeSkus: '2374, 2375, 2376, 2377',
        size: 'L',
        name: 'Pre &amp; Post Maternity/Nursing Full Length Nighty with both sides Zipper for Easy Feeding - Little Hearts - Navy - L',
        webUrl:
          'mylofamily.com/essentials/pre-post-maternitynursing-full-length-nighty-with-both-sides-zipper-for-easy-feeding---little-hearts-2375',
        imageUrl:
          'https://images.myloapp.in/NestJsUploads/1680083392972-2374,-2375,-2376,-2377-(1).webp',
        sizeChartUrl:
          'https://images.myloapp.in/gullack_products/product_1647254899_1925341984.jpeg',
        MRP: 1999,
        strikeprice: 1999,
        price: 1299,
        Discount: 0.35,
      },
    ],
    banner: images?.nighties,
    heading: 'Nighties',
    id: 4,
  },
  {
    items: [
      {
        product_id: 1021,
        sectionOrder: 5,
        style: 'Maternity Bra',
        print: 'Classic Black',
        showOnLp: true,
        sizeSkus: '1020, 1021, 1022, 1023, 1024, 1025, 1026',
        size: '32B',
        name: 'Maternity/Nursing Bras Non-Wired, Non-Padded with free Bra Extender – Classic Black 32 B',
        webUrl:
          'mylofamily.com/essentials/maternity-nursing-bras-non-wired-non-padded-with-free-bra-extender-classic-black-32-b-1021',
        imageUrl:
          'https://images.myloapp.in/gullack_products/product_1644815539_1350243326.webp',
        sizeChartUrl:
          'https://images.myloapp.in/gullack_products/product_1644825964_2090404188.jpeg',
        MRP: 229,
        strikeprice: 299,
        price: 219,
        Discount: 0.04,
      },
      {
        product_id: 1028,
        sectionOrder: 5,
        style: 'Maternity Bra',
        print: 'Classic White',
        showOnLp: true,
        sizeSkus: '1027, 1028, 1029, 1030, 1031, 1032, 1033',
        size: '32B',
        name: 'Maternity/Nursing Bras Non-Wired, Non-Padded with free Bra Extender- Classic White 32 B',
        webUrl:
          'mylofamily.com/essentials/maternity-nursing-bras-non-wired-non-padded-with-free-bra-extender-classic-white-32-b-1028',
        imageUrl:
          'https://images.myloapp.in/gullack_products/product_1644904003_131335849.webp',
        sizeChartUrl:
          'https://images.myloapp.in/gullack_products/product_1644825964_2090404188.jpeg',
        MRP: 229,
        strikeprice: 299,
        price: 219,
        Discount: 0.04,
      },
      {
        product_id: 1035,
        sectionOrder: 5,
        style: 'Maternity Bra',
        print: 'Magnolia Cream',
        showOnLp: true,
        sizeSkus: '1034, 1035, 1036, 1037, 1038, 1039, 1040',
        size: '32B',
        name: 'Maternity/Nursing Bras Non-Wired, Non-Padded with free Bra Extender - Magnolia Cream 32 B',
        webUrl:
          'mylofamily.com/essentials/maternity-nursing-bras-non-wired-non-padded-with-free-bra-extender-magnolia-cream-32-b-1035',
        imageUrl:
          'https://images.myloapp.in/gullack_products/product_1645013345_962648846.webp',
        sizeChartUrl:
          'https://images.myloapp.in/gullack_products/product_1644825964_2090404188.jpeg',
        MRP: 229,
        strikeprice: 299,
        price: 219,
        Discount: 0.04,
      },
      {
        product_id: 1042,
        sectionOrder: 5,
        style: 'Maternity Bra',
        print: 'Persian Blue',
        showOnLp: true,
        sizeSkus: '1041, 1042, 1043, 1044, 1045, 1046, 1047',
        size: '32B',
        name: 'Maternity/Nursing Bras Non-Wired, Non-Padded with free Bra Extender – Persian Blue 32 B',
        webUrl:
          'mylofamily.com/essentials/maternity-nursing-bras-non-wired-non-padded-with-free-bra-extender-persian-blue-32-b-1042',
        imageUrl:
          'https://images.myloapp.in/gullack_products/product_1645015157_358156068.webp',
        sizeChartUrl:
          'https://images.myloapp.in/gullack_products/product_1644825964_2090404188.jpeg',
        MRP: 229,
        strikeprice: 299,
        price: 219,
        Discount: 0.04,
      },
      {
        product_id: 1049,
        sectionOrder: 5,
        style: 'Maternity Bra',
        print: 'Dark Pink',
        showOnLp: true,
        sizeSkus: '1048, 1049, 1050, 1051, 1052, 1053, 1054',
        size: '32B',
        name: 'Maternity/Nursing Bras Non-Wired, Non-Padded with free Bra Extender - Dark Pink 32 B',
        webUrl:
          'mylofamily.com/essentials/maternity-nursing-bras-non-wired-non-padded-with-free-bra-extender-dark-pink-32-b-1049',
        imageUrl:
          'https://images.myloapp.in/gullack_products/product_1644825671_1089486857.jpeg',
        sizeChartUrl:
          'https://images.myloapp.in/gullack_products/product_1644825964_2090404188.jpeg',
        MRP: 229,
        strikeprice: 299,
        price: 219,
        Discount: 0.04,
      },
      {
        product_id: 1056,
        sectionOrder: 5,
        style: 'Maternity Bra',
        print: 'Sandalwood',
        showOnLp: true,
        sizeSkus: '1055, 1056, 1057, 1058, 1059, 1060, 1061',
        size: '32B',
        name: 'Maternity/Nursing Bras Non-Wired, Non-Padded with free Bra Extender - Sandalwood 32 B',
        webUrl:
          'mylofamily.com/essentials/maternity-nursing-bras-non-wired-non-padded-with-free-bra-extender-sandalwood-32-b-1056',
        imageUrl:
          'https://images.myloapp.in/gullack_products/product_1644842377_1852820341.jpeg',
        sizeChartUrl:
          'https://images.myloapp.in/gullack_products/product_1644825964_2090404188.jpeg',
        MRP: 229,
        strikeprice: 299,
        price: 219,
        Discount: 0.04,
      },
      {
        product_id: 1773,
        sectionOrder: 5,
        style: 'Maternity Bra',
        print: 'Moulded Spacer Cup - Coral',
        showOnLp: true,
        sizeSkus: '1773, 1774, 1776, 1777, 1779, 1780',
        size: '32B',
        name: 'Maternity/Nursing Moulded Spacer Cup Bra with free bra extender -Coral 32 B',
        webUrl:
          'mylofamily.com/essentials/maternity-nursing-moulded-spacer-cup-bra-with-free-bra-extender-coral-32-b-1773',
        imageUrl:
          'https://images.myloapp.in/gullack_products/product_1642155042_1841655928.jpeg',
        sizeChartUrl:
          'https://images.myloapp.in/gullack_products/product_1644825964_2090404188.jpeg',
        MRP: 499,
        strikeprice: 499,
        price: 499,
        Discount: 0,
      },
      {
        product_id: 1782,
        sectionOrder: 5,
        style: 'Maternity Bra',
        print: 'Moulded Spacer Cup - Navy',
        showOnLp: true,
        sizeSkus: '1782, 1784, 1785, 1786, 1788, 1789',
        size: '32B',
        name: 'Maternity/Nursing Moulded Spacer Cup Bra with free bra extender -Navy 32 B',
        webUrl:
          'mylofamily.com/essentials/maternity-nursing-moulded-spacer-cup-bra-with-free-bra-extender-navy-32-b-1782',
        imageUrl:
          'https://images.myloapp.in/gullack_products/product_1642159437_1970430973.webp',
        sizeChartUrl:
          'https://images.myloapp.in/gullack_products/product_1644825964_2090404188.jpeg',
        MRP: 499,
        strikeprice: 499,
        price: 499,
        Discount: 0,
      },
      {
        product_id: 1791,
        sectionOrder: 5,
        style: 'Maternity Bra',
        print: 'Moulded Spacer Cup - Skin',
        showOnLp: true,
        sizeSkus: '1791, 1792, 1794, 1796, 1797, 1798',
        size: '32B',
        name: 'Maternity/Nursing Moulded Spacer Cup Bra with free bra extender -Skin 32 B',
        webUrl:
          'mylofamily.com/essentials/maternity-nursing-moulded-spacer-cup-bra-with-free-bra-extender-skin-32-b-1791',
        imageUrl:
          'https://images.myloapp.in/gullack_products/product_1642394115_319675835.jpeg',
        sizeChartUrl:
          'https://images.myloapp.in/gullack_products/product_1644825964_2090404188.jpeg',
        MRP: 499,
        strikeprice: 499,
        price: 499,
        Discount: 0,
      },
      {
        product_id: 1823,
        sectionOrder: 5,
        style: 'Maternity Bra',
        print: 'Light Padded Skin',
        showOnLp: true,
        sizeSkus: '1823, 1824, 1825, 1826, 1827, 1828',
        size: '32B',
        name: 'Light Padded Maternity/Nursing Bra with free bra extender-Skin 32B',
        webUrl:
          'mylofamily.com/essentials/light-padded-maternitynursing-bra-with-free-bra-extender-skin-32b-1823',
        imageUrl:
          'https://images.myloapp.in/gullack_products/product_1642494599_526699551.jpeg',
        sizeChartUrl:
          'https://images.myloapp.in/gullack_products/product_1642494932_359407461.webp',
        MRP: 599,
        strikeprice: 599,
        price: 499,
        Discount: 0.17,
      },
      {
        product_id: 1829,
        sectionOrder: 5,
        style: 'Maternity Bra',
        print: 'Light Padded Fuchsia',
        showOnLp: true,
        sizeSkus: '1829, 1830, 1831, 1832, 1833, 1834',
        size: '32B',
        name: 'Light Padded Maternity/Nursing Bra with free bra extender-Fuchsia 32B',
        webUrl:
          'mylofamily.com/essentials/light-padded-maternitynursing-bra-with-free-bra-extender-fuchsia-32b-1829',
        imageUrl:
          'https://images.myloapp.in/gullack_products/product_1642499685_459338828.webp',
        sizeChartUrl:
          'https://images.myloapp.in/gullack_products/product_1642494932_359407461.webp',
        MRP: 599,
        strikeprice: 599,
        price: 499,
        Discount: 0.17,
      },
      {
        product_id: 1836,
        sectionOrder: 5,
        style: 'Maternity Bra',
        print: 'Light Padded Plum',
        showOnLp: true,
        sizeSkus: '1835, 1836, 1837, 1838, 1839, 1840',
        size: '34B',
        name: 'Light Padded Maternity/Nursing Bra with free bra extender-Plum 34B',
        webUrl:
          'mylofamily.com/essentials/light-padded-maternitynursing-bra-with-free-bra-extender-plum-34b-1836',
        imageUrl:
          'https://images.myloapp.in/gullack_products/product_1642503404_1494755227.webp',
        sizeChartUrl:
          'https://images.myloapp.in/gullack_products/product_1642494932_359407461.webp',
        MRP: 599,
        strikeprice: 599,
        price: 499,
        Discount: 0.17,
      },
      {
        product_id: 1938,
        sectionOrder: 5,
        style: 'Maternity Bra',
        print: 'Extra Comfort - Dusty Grey Melange',
        showOnLp: true,
        sizeSkus: '1938, 1939, 1940, 1941, 1942, 1943',
        size: '32B',
        name: 'Maternity/Nursing Moulded Cup Extra Comfort Bra with free Bra Extender - Dusty Grey Melange 32B',
        webUrl:
          'mylofamily.com/essentials/maternitynursing-moulded-cup-extra-comfort-bra-with-free-bra-extender---dusty-grey-melange-32b-1938',
        imageUrl:
          'https://images.myloapp.in/gullack_products/product_1643944170_1603494530.jpeg',
        sizeChartUrl:
          'https://images.myloapp.in/gullack_products/product_1642155823_878661219.jpeg',
        MRP: 399,
        strikeprice: 399,
        price: 369,
        Discount: 0.08,
      },
      {
        product_id: 1944,
        sectionOrder: 5,
        style: 'Maternity Bra',
        print: 'Extra Comfort - Light Blue Melange',
        showOnLp: true,
        sizeSkus: '1944, 1945, 1946, 1947, 1948, 1949',
        size: '32B',
        name: 'Maternity/Nursing Moulded Cup Extra Comfort Bra with free Bra Extender - Lt Blue Melange 32B',
        webUrl:
          'mylofamily.com/essentials/maternitynursing-moulded-cup-extra-comfort-bra-with-free-bra-extender---lt-blue-melange-32b-1944',
        imageUrl:
          'https://images.myloapp.in/gullack_products/product_1643974871_2061386978.webp',
        sizeChartUrl:
          'https://images.myloapp.in/gullack_products/product_1642155823_878661219.jpeg',
        MRP: 399,
        strikeprice: 399,
        price: 369,
        Discount: 0.08,
      },
      {
        product_id: 1950,
        sectionOrder: 5,
        style: 'Maternity Bra',
        print: 'Extra Comfort Coral Pink Melange',
        showOnLp: true,
        sizeSkus: '1950, 1951, 1952, 1953, 1954, 1955',
        size: '32B',
        name: 'Maternity/Nursing Moulded Cup Extra Comfort Bra with free Bra Extender - Coral Pink Melange 32B',
        webUrl:
          'mylofamily.com/essentials/maternitynursing-moulded-cup-extra-comfort-bra-with-free-bra-extender---coral-pink-melange-32b-1950',
        imageUrl:
          'https://images.myloapp.in/gullack_products/product_1644172885_1840786283.webp',
        sizeChartUrl:
          'https://images.myloapp.in/gullack_products/product_1642155823_878661219.jpeg',
        MRP: 399,
        strikeprice: 399,
        price: 369,
        Discount: 0.08,
      },
    ],
    banner: images?.maternityBra,
    heading: 'Maternity Bras',
    id: 5,
  },
  {
    items: [
      {
        product_id: 2404,
        sectionOrder: 6,
        style: 'Leggings',
        print: 'Beige Leggings',
        showOnLp: true,
        sizeSkus: '2403, 2404, 2405, 2406',
        size: 'L',
        name: 'Stretchable Pregnancy&Post Delivery Leggings - Beige (L)',
        webUrl:
          'mylofamily.com/store/stretchable-pregnancy-post-delivery-leggings---beige-l-2404',
        imageUrl:
          'https://images.myloapp.in/gullack_products/product_1657177297_211856975.jpeg',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156348-leggings.webp',
        MRP: 1149,
        status: 'Active',
        strikeprice: 1149,
        price: 999,
        Discount: 0.130548302872063,
      },
      {
        product_id: 611,
        sectionOrder: 6,
        style: 'Leggings',
        print: 'Black Leggings',
        showOnLp: true,
        sizeSkus: '610, 611, 612, 613',
        size: 'L',
        name: 'Stretchable Pregnancy&Post Delivery Leggings - Black (L)',
        webUrl:
          'mylofamily.com/essentials/stretchable-pregnancy-post-delivery-leggings-black-l-611',
        imageUrl:
          'https://images.myloapp.in/gullack_products/product_1664795008_1477089856.jpeg',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156348-leggings.webp',
        MRP: 1149,
        status: 'Active',
        strikeprice: 1149,
        price: 999,
        Discount: 0.130548302872063,
      },
      {
        product_id: 615,
        sectionOrder: 6,
        style: 'Leggings',
        print: 'Dark Grey Leggings',
        showOnLp: true,
        sizeSkus: '614, 615, 616, 617',
        size: 'L',
        name: 'Stretchable Pregnancy&Post Delivery Leggings - Dark Grey (L)',
        webUrl:
          'mylofamily.com/essentials/stretchable-pregnancy-post-delivery-leggings-dark-grey-l-615',
        imageUrl:
          'https://images.myloapp.in/gullack_products/product_1664797143_819526072.jpeg',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156348-leggings.webp',
        MRP: 1149,
        status: 'Active',
        strikeprice: 1149,
        price: 999,
        Discount: 0.130548302872063,
      },
      {
        product_id: 2400,
        sectionOrder: 6,
        style: 'Leggings',
        print: 'Navy Leggings',
        showOnLp: true,
        sizeSkus: '2399, 2400, 2401, 2402',
        size: 'L',
        name: 'Stretchable Pregnancy&Post Delivery Leggings - Navy (L)',
        webUrl:
          'mylofamily.com/store/stretchable-pregnancy-post-delivery-leggings---navy-l-2400',
        imageUrl:
          'https://images.myloapp.in/gullack_products/product_1657129636_1434852848.jpeg',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156348-leggings.webp',
        MRP: 1149,
        status: 'Active',
        strikeprice: 1149,
        price: 999,
        Discount: 0.130548302872063,
      },
      {
        product_id: 619,
        sectionOrder: 6,
        style: 'Leggings',
        print: 'White Leggings',
        showOnLp: true,
        sizeSkus: '618, 619, 620, 621',
        size: 'L',
        name: 'Stretchable Pregnancy&Post Delivery Leggings - White (L)',
        webUrl:
          'mylofamily.com/essentials/stretchable-pregnancy-post-delivery-leggings-white-l-619',
        imageUrl:
          'https://images.myloapp.in/gullack_products/product_1664800098_1130744729.jpeg',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156348-leggings.webp',
        MRP: 1149,
        status: 'Active',
        strikeprice: 1149,
        price: 999,
        Discount: 0.130548302872063,
      },
    ],
    banner: images?.leggings,
    heading: 'Leggings',
    id: 6,
  },
  {
    items: [
      {
        product_id: 2199,
        sectionOrder: 7,
        style: 'Panties',
        print: 'Black Beauty',
        showOnLp: true,
        sizeSkus: '2198, 2199, 2200, 2201',
        size: 'L',
        name: 'High Waist Maternity/Postpartum Panty - Anti-Microbial with Comfy Adjustable Waistband – Black Beauty –L',
        webUrl:
          'mylofamily.com/essentials/high-waist-bamboo-elasthane-comfy-maternitypostpartum-panty-with-adjustable-waistband-black-l-2199',
        imageUrl:
          'https://images.myloapp.in/gullack_products/product_1654584687_56808333.jpeg',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156347-panties.webp',
        MRP: 449,
        status: 'OOS',
        strikeprice: 499,
        price: 429,
        Discount: 0.111358574610245,
      },
      {
        product_id: 2951,
        sectionOrder: 7,
        style: 'Panties',
        print: 'Cloud Grey',
        showOnLp: true,
        sizeSkus: '2950, 2951, 2952, 2953',
        size: 'L',
        name: 'High Waist Maternity/Postpartum Panty - Anti-Microbial with Comfy Adjustable Waistband – Cloud Grey –L',
        webUrl:
          'mylofamily.com/essentials/high-waist-antimicrobial-comfy-maternitypostpartum-panty-with-adjustable-waistband-grey-l-2951',
        imageUrl:
          'https://images.myloapp.in/gullack_products/product_1668591712_680641267.jpeg',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156347-panties.webp',
        MRP: 499,
        status: 'Active',
        strikeprice: 499,
        price: 429,
        Discount: 0.140280561122244,
      },
      {
        product_id: 2959,
        sectionOrder: 7,
        style: 'Panties',
        print: 'Cloud Grey&Ruby Wine',
        showOnLp: true,
        sizeSkus: '2958, 2959, 2960, 2961',
        size: 'L',
        name: 'High Waist Maternity/Postpartum Panty - Anti-Microbial with Comfy Adjustable Waistband – Cloud Grey&Ruby Wine-L-Pack of 2',
        webUrl:
          'mylofamily.com/essentials/high-waist-bamboo-elasthane-comfy-maternitypostpartum-panty-with-adjustable-waistband-pack-of-2---ru-2959',
        imageUrl:
          'https://images.myloapp.in/gullack_products/product_1669110991_193717513.jpeg',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156347-panties.webp',
        MRP: 998,
        status: 'Active',
        strikeprice: 898,
        price: 729,
        Discount: 0.269539078156313,
      },
      {
        product_id: 2195,
        sectionOrder: 7,
        style: 'Panties',
        print: 'Dazzling Blue',
        showOnLp: true,
        sizeSkus: '2194, 2195, 2196, 2197',
        size: 'L',
        name: 'High Waist Maternity/Postpartum Panty - Anti-Microbial with Comfy Adjustable Waistband – Dazzling Blue –L',
        webUrl:
          'mylofamily.com/essentials/high-waist-bamboo-maternitypostpartum-panty-with-adjustable-waistband-royal-blue--l-2195',
        imageUrl:
          'https://images.myloapp.in/gullack_products/product_1666895956_149408835.jpeg',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156347-panties.webp',
        MRP: 449,
        status: 'OOS',
        strikeprice: 499,
        price: 429,
        Discount: 0.111358574610245,
      },
      {
        product_id: 2203,
        sectionOrder: 7,
        style: 'Panties',
        print: 'Dazzling Blue&Black Beauty',
        showOnLp: true,
        sizeSkus: '2202, 2203, 2204, 2205',
        size: 'L',
        name: 'High Waist Maternity/Postpartum Panty - Anti-Microbial with Comfy Adjustable Waistband - Dazzling Blue&Black Beauty - L - Pack of 2',
        webUrl:
          'mylofamily.com/essentials/high-waist-bamboo-elasthane-comfy-maternitypostpartum-panty-with-adjustable-waistband-pack-of-2---ro-2203',
        imageUrl:
          'https://images.myloapp.in/gullack_products/product_1667994105_528852670.jpeg',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156347-panties.webp',
        MRP: 898,
        status: 'OOS',
        strikeprice: 898,
        price: 789,
        Discount: 0.121380846325167,
      },
      {
        product_id: 2955,
        sectionOrder: 7,
        style: 'Panties',
        print: 'French Vanilla',
        showOnLp: true,
        sizeSkus: '2954, 2955, 2956, 2957',
        size: 'L',
        name: 'High Waist Maternity/Postpartum Panty - Anti-Microbial with Comfy Adjustable Waistband – French Vanilla –L',
        webUrl:
          'mylofamily.com/essentials/high-waist-antimicrobial-comfy-maternitypostpartum-panty-with-adjustable-waistband-vanilla-nude-l-2955',
        imageUrl:
          'https://images.myloapp.in/gullack_products/product_1668603304_640823708.jpeg',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156347-panties.webp',
        MRP: 499,
        status: 'Active',
        strikeprice: 499,
        price: 429,
        Discount: 0.140280561122244,
      },
      {
        product_id: 2967,
        sectionOrder: 7,
        style: 'Panties',
        print: 'French Vanilla&Ruby Wine',
        showOnLp: true,
        sizeSkus: '2966, 2967, 2968, 2969',
        size: 'L',
        name: 'High Waist Maternity/Postpartum Panty - Anti-Microbial with Comfy Adjustable Waistband – French Vanilla&Ruby Wine-L- Pack of 2',
        webUrl:
          'mylofamily.com/essentials/high-waist-bamboo-elasthane-comfy-maternitypostpartum-panty-with-adjustable-waistband-pack-of-2---fr-2967',
        imageUrl:
          'https://images.myloapp.in/gullack_products/product_1669107208_2139420629.jpeg',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156347-panties.webp',
        MRP: 998,
        status: 'Active',
        strikeprice: 998,
        price: 729,
        Discount: 0.269539078156313,
      },
      {
        product_id: 2835,
        sectionOrder: 7,
        style: 'Panties',
        print: 'Ruby Wine',
        showOnLp: true,
        sizeSkus: '2834, 2835, 2836, 2837',
        size: 'L',
        name: 'High Waist Maternity/Postpartum Panty - Anti-Microbial with Comfy Adjustable Waistband – Ruby Wine –L',
        webUrl:
          'mylofamily.com/essentials/high-waist-antimicrobial-comfy-maternitypostpartum-panty-with-adjustable-waistband-maroon-l-2835',
        imageUrl:
          'https://images.myloapp.in/gullack_products/product_1667553336_1496963378.jpeg',
        sizeChartUrl:
          'https://images.myloapp.in/NestJsUploads/1678711156347-panties.webp',
        MRP: 499,
        status: 'Active',
        strikeprice: 499,
        price: 429,
        Discount: 0.140280561122244,
      },
    ],
    banner: images?.panties,
    heading: 'Panties',
    id: 7,
  },
];

// export const fn = (oldData, newData) => {
//     newData.map((newItem) => {
//         oldData.map((oldItem) => {
//             oldItem.items.map((item) => {
//                 if (item.product_id === newItem.product_id) {
//                     item.price = newItem.price;
//                     item.strikeprice = newItem.strikeprice;
//                 }
//             });
//         });
//     });
// };
// fn(maternityGeneralItem, newData);
// console.log(maternityGeneralItem);
